import { Dropdown, Menu, MenuProps, Layout } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SettingsDrawer from "../SettingsDrawer";
import useConfigStore from "../../useConfigStore";
import { sdkOptionsKey } from "../../EmbedConfigContext";
import { isInternalMode } from "../../isInternal";
import { getSdkEnvironment, sdkSources, SdkEnvironment } from "../../sdkEnvironment";

const items: MenuProps['items'] = [
  {
    label: 'Home',
    key: '/',
  },
  {
    label: 'Chat',
    key: '/chat',
  },
  {
    label: 'Autocomplete with search results',
    key: '/search',
  },
  {
    label: 'Modal search',
    key: '/modal-search',
  },
  {
    label: 'Sidebar',
    key: '/sidebar',
  },
];

const morePageItems: MenuProps['items'] = [
  {
    label: 'Settings',
    key: '/settings',
  },
  {
    label: 'Library',
    key: '/library',
  },
];

const Header = () => {
  const isInternal = isInternalMode()

  const contextValue = useConfigStore()
  const [settingsOpen, setSettingsOpen] = useState(false)
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const onClick: MenuProps['onClick'] = (e) => navigate(e.key);
  const sdkSource = contextValue.config[sdkOptionsKey].source;
  const selectedEnvironment = getSdkEnvironment(sdkSource);

  const onSdkEnvironmentChange = (environment: SdkEnvironment) => {
    contextValue.setConfig({
      ...contextValue.config,
      [sdkOptionsKey]: {
        ...contextValue.config[sdkOptionsKey],
        source: sdkSources[environment],
      },
    });
  };

  return (
    <Layout.Header className="bg-white w-full flex items-center flex-grow-0 px-4 w-fixed w-full flex-shrink flex-grow-0 px-4 border-b border-gray-20 shadow-md">
      <div className="flex shrink-0 items-center">
        <Menu
          mode="horizontal"
          disabledOverflow
          selectedKeys={[pathname]}
          items={items}
          onClick={onClick}
        />
        <Dropdown
          menu={{ items: morePageItems, onClick }}
          trigger={['click']}
        >
          <button
            type="button"
            aria-label="More pages"
            title="More pages"
            className="ml-1 flex items-center justify-center rounded p-2 hover:bg-gray-100"
          >
            <EllipsisOutlined aria-hidden="true" style={{ fontSize: "18px" }} />
          </button>
        </Dropdown>
      </div>
      <div className="ml-auto flex shrink-0 items-center" style={{lineHeight: "16px"}}>
        {isInternal && (<>
          <select
            id="sdk-environment"
            aria-label="SDK environment"
            value={selectedEnvironment}
            onChange={(event) => onSdkEnvironmentChange(event.target.value as SdkEnvironment)}
            className="mr-3 rounded border border-gray-300 bg-white px-2 py-1"
          >
            <option value="" disabled>Custom source</option>
            {Object.keys(sdkSources).map((environment) => (
              <option key={environment} value={environment}>{environment}</option>
            ))}
          </select>
          </>
        )}
        <button onClick={() => setSettingsOpen(true)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-settings"
          >
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
          </svg>
        </button>

      </div>
      <SettingsDrawer open={settingsOpen} onClose={() => setSettingsOpen(false)}/>
    </Layout.Header>
  )
};

export default Header;
